import React, { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '../../utils/cn';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'gold' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'lg',
  href,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-navy text-white hover:bg-navy-800 focus:ring-navy',
    secondary: 'bg-slate-100 text-navy hover:bg-slate-200 focus:ring-slate-200',
    gold: 'bg-gold text-white hover:bg-gold-500 focus:ring-gold shadow-lg shadow-gold/30',
    outline: 'border-2 border-navy text-navy hover:bg-navy hover:text-white focus:ring-navy'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = cn(baseStyles, variants[variant], sizes[size], className);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Fire a Meta Pixel purchase-intent event on the main CTA buttons
    if (variant === 'gold' && typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
    if (href) {
      e.preventDefault();
      if (href.startsWith('#')) {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      } else {
        window.location.href = href;
      }
    }
    props.onClick?.(e);
  };
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} onClick={handleClick} {...props} data-id="element-331">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';